/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

/**
 * CANONICAL MENU ORDER (2026-08-13) — every role's menu follows the same
 * sequence; roles simply omit the entries they can't reach. When adding a new
 * item, slot it into this order in EVERY array below rather than appending:
 *
 *   Dashboard · Statistici · Utilizatori · Comenzi · Fișiere · Media ·
 *   Produse digitale · Linkuri de plată · Marketing · CMS · Asignări ·
 *   Cupoane · Academania · Produse fizice · Orar · Corecturi · Înscrieri ·
 *   Jocuri · Utilitare
 *
 * Roles that surface a single child of a group in place of the group (e.g. the
 * teacher's „Cursuri"/„Grupe Plus" instead of „Produse digitale", or
 * „Corectare lucrări" instead of „Corecturi") take that group's slot.
 */

export const adminParentNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar-square',
        link : '/dashboard'
    },
    {
        id   : 'statistics',
        title: 'Statistici',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/statistici'
    },
    {
        id   : 'users',
        title: 'Utilizatori',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/utilizatori',
    },
    {
        id   : 'orders',
        title: 'Comenzi',
        type : 'basic',
        icon : 'heroicons_outline:credit-card',
        link : '/comenzi'
    },
    {
        id   : 'files',
        title: 'Fișiere',
        type : 'basic',
        icon : 'heroicons_outline:folder',
        link : '/fisiere'
    },
    {
        id   : 'media',
        title: 'Media',
        type : 'collapsable',
        icon : 'heroicons_outline:photo',
        children: [
            {
                id   : 'media-generale',
                title: 'Generale',
                type : 'basic',
                icon : 'heroicons_outline:folder',
                link : '/media/generale',
            },
            {
                id   : 'media-produse',
                title: 'Produse',
                type : 'basic',
                icon : 'heroicons_outline:shopping-bag',
                link : '/media/produse',
            },
            {
                id   : 'media-poze',
                title: 'Poze',
                type : 'basic',
                icon : 'heroicons_outline:camera',
                link : '/media/poze',
            },
            {
                id   : 'media-html',
                title: 'HTML',
                type : 'basic',
                icon : 'heroicons_outline:code-bracket',
                link : '/media/html',
            },
        ],
    },
    {
        id   : 'digital-products',
        title: 'Produse digitale',
        type : 'collapsable',
        icon : 'heroicons_outline:computer-desktop',
        children: [
            {
                id   : 'courses',
                title: 'Cursuri',
                type : 'basic',
                icon : 'heroicons_outline:book-open',
                link : '/cursuri'
            },
            {
                id   : 'simulations',
                title: 'Simulări',
                type : 'basic',
                icon : 'heroicons_outline:calculator',
                link : '/simulari'
            },
            // 'Teme' moved to the 'Corecturi' group (2026-08-07).
            {
                id   : 'group-products',
                title: 'Grupe Plus',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/grupe-plus'
            },
            {
                id   : 'exercise-module',
                title: 'Exerciții',
                type : 'basic',
                icon : 'heroicons_outline:puzzle-piece',
                link : '/exercise-modules'
            },
            {
                id   : 'video-module',
                title: 'Lecții video',
                type : 'basic',
                icon : 'heroicons_outline:play-circle',
                link : '/video-modules'
            },
            {
                id   : 'custom-events',
                title: 'Evenimente',
                type : 'basic',
                icon : 'heroicons_outline:cake',
                link : '/evenimente-custom'
            },
            {
                id   : 'summer-workshops',
                title: 'Ateliere de vară',
                type : 'basic',
                icon : 'heroicons_outline:sparkles',
                link : '/ateliere-de-vara'
            },
            {
                id   : 'summer-courses',
                title: 'Cursuri de vară',
                type : 'basic',
                icon : 'heroicons_outline:sun',
                link : '/cursuri-de-vara'
            },
            // 'Ateliere' (workshops) removed from the MENU only (2026-07-17) —
            // the /ateliere route and page still exist.
        ]
    },
    {
        id   : 'payment-links',
        title: 'Linkuri de plată',
        type : 'basic',
        icon : 'heroicons_outline:link',
        link : '/linkuri-de-plata'
    },
    {
        id   : 'marketing',
        title: 'Marketing',
        type : 'basic',
        icon : 'heroicons_outline:device-phone-mobile',
        link : '/marketing'
    },
    {
        id   : 'cms',
        title: 'CMS',
        type : 'collapsable',
        icon : 'heroicons_outline:document-text',
        children: [
            { id: 'cms-staff',          title: 'Profesori',                 type: 'basic', icon: 'heroicons_outline:user-group',    link: '/cms/staff' },
            { id: 'cms-faqs',           title: 'Întrebări frecvente',       type: 'basic', icon: 'heroicons_outline:chat-bubble-left-right', link: '/cms/faqs' },
            { id: 'cms-reviews',        title: 'Recenzii',                  type: 'basic', icon: 'heroicons_outline:star',          link: '/cms/reviews' },
            { id: 'cms-articles',       title: 'Blog (articole)',           type: 'basic', icon: 'heroicons_outline:newspaper',     link: '/cms/articles' },
            { id: 'cms-logo',           title: 'Logo',                      type: 'basic', icon: 'heroicons_outline:photo',         link: '/cms/logo' },
            { id: 'cms-popup',          title: 'Popup abonare',             type: 'basic', icon: 'heroicons_outline:bell-alert',    link: '/cms/popup' },
            { id: 'cms-courses',        title: 'Cursuri (pagini)',          type: 'basic', icon: 'heroicons_outline:academic-cap',  link: '/cms/courses' },
            { id: 'cms-groups',         title: 'Grupe Plus (pagini)',       type: 'basic', icon: 'heroicons_outline:user-group',    link: '/cms/groups' },
            { id: 'cms-workshops',      title: 'Școli de vară',             type: 'basic', icon: 'heroicons_outline:trophy',        link: '/cms/workshops' },
            { id: 'cms-library-offers', title: 'Hero Bibliotecă (pe clase)', type: 'basic', icon: 'heroicons_outline:rectangle-stack', link: '/cms/library-offers' },
        ],
    },
    {
        id   : 'assignments',
        title: 'Asignări',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/asignari'
    },
    {
        id   : 'vouchers',
        title: 'Cupoane',
        type : 'basic',
        icon : 'heroicons_outline:gift',
        link : '/cupoane'
    },
    {
        id   : 'academania',
        title: 'Academania',
        type : 'collapsable',
        icon : 'heroicons_outline:academic-cap',
        children: [
            {
                id   : 'tags',
                title: 'Tag-uri',
                type : 'basic',
                icon : 'heroicons_outline:book-open',
                link : '/academania/tag-manager'
            },
            {
                id   : 'category-tags',
                title: 'Categorii Tag-uri',
                type : 'basic',
                icon : 'heroicons_outline:book-open',
                link : '/academania/category-tag-manager'
            },
            {
                id   : 'exercise-modules',
                title: 'Module exerciții',
                type : 'basic',
                icon : 'heroicons_outline:calculator',
                link : '/academania/module-exercitii'
            },
            {
                id   : 'video-modules',
                title: 'Lecții video',
                type : 'basic',
                icon : 'heroicons_outline:film',
                link : '/academania/lectii-video'
            },
            {
                id   : 'exercises-resources',
                title: 'Resurse',
                type : 'basic',
                icon : 'heroicons_outline:photo',
                link : '/academania/resurse'
            }
        ]
    },
    {
        id   : 'physical-products',
        title: 'Produse fizice',
        type : 'basic',
        icon : 'heroicons_outline:shopping-bag',
        link : '/produse-fizice'
    },
    {
        id   : 'timetable',
        title: 'Orar',
        type : 'basic',
        icon : 'heroicons_outline:calendar-days',
        link : '/orar'
    },
    {
        id   : 'corrections',
        title: 'Corecturi',
        type : 'collapsable',
        icon : 'heroicons_outline:pencil-square',
        children: [
            {
                id   : 'corrections-homework',
                title: 'Teme',
                type : 'basic',
                icon : 'heroicons_outline:document-check',
                link : '/corecturi/teme'
            },
            {
                id   : 'corrections-simulations',
                title: 'Simulări',
                type : 'basic',
                icon : 'heroicons_outline:calculator',
                link : '/corecturi/simulari'
            },
        ],
    },
    // Grupe Plus feedback — every grupă, with the Profesor filter.
    {
        id   : 'group-feedback',
        title: 'Feedback',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-left-right',
        link : '/feedback'
    },
    // The "Diplome" and "Înscrieri" tabs stay visible regardless of their feature
    // toggles — the admin manages those from inside the tabs (see NavigationService).
    {
        id   : 'registrations',
        title: 'Înscrieri',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-list',
        link : '/inscrieri'
    },
    {
        id   : 'playground',
        title: 'Jocuri',
        type : 'basic',
        icon : 'heroicons_outline:puzzle-piece',
        link : '/playground'
    },
    {
        id   : 'utilitare',
        title: 'Utilitare',
        type : 'collapsable',
        icon : 'heroicons_outline:wrench-screwdriver',
        children: [
            // Simulation day: child → room, the same page the simulation team uses.
            { id: 'simulation-lookup', title: 'Caută copil (simulări)', type: 'basic', icon: 'heroicons_outline:magnifying-glass',        link: '/cauta-copil' },
            { id: 'email-templates', title: 'Emails',           type: 'basic', icon: 'heroicons_outline:envelope',                link: '/email-templates' },
            { id: 'mail-queue',      title: 'Coadă email',       type: 'basic', icon: 'heroicons_outline:queue-list',              link: '/coada-email' },
            { id: 'diplome',         title: 'Diplome',           type: 'basic', icon: 'heroicons_outline:academic-cap',            link: '/diplome' },
            { id: 'share',           title: 'Distribuie',        type: 'basic', icon: 'heroicons_outline:share',                   link: '/share' },
            { id: 'export',          title: 'Export',            type: 'basic', icon: 'heroicons_outline:archive-box-arrow-down',  link: '/export' },
            { id: 'jobs',            title: 'Jobs',              type: 'basic', icon: 'heroicons_outline:bolt',                     link: '/jobs' },
            // Monday's logs report (Radar Matemanie · Loguri) and its switches.
            { id: 'logs-report',     title: 'Raport loguri',     type: 'basic', icon: 'heroicons_outline:document-magnifying-glass', link: '/raport-loguri' },
            { id: 'audit-timeline',  title: 'Jurnal activitate', type: 'basic', icon: 'heroicons_outline:clipboard-document-list', link: '/jurnal' },
            { id: 'cookie-consent',  title: 'Cookie-uri',        type: 'basic', icon: 'heroicons_outline:shield-check',            link: '/cookies' },
            // The four footer documents of the main site, each behind its own editor
            // (modules/admin/legal-documents). Footer order.
            {
                id: 'legal-documents', title: 'Documente', type: 'collapsable', icon: 'heroicons_outline:document-text',
                children: [
                    { id: 'legal-return-policy',  title: 'Politica de retur',            type: 'basic', link: '/documente/politica-de-retur' },
                    { id: 'legal-privacy-policy', title: 'Politica de confidențialitate', type: 'basic', link: '/documente/politica-de-confidentialitate' },
                    { id: 'legal-terms',          title: 'Termeni și condiții',          type: 'basic', link: '/documente/termeni-si-conditii' },
                    { id: 'legal-cookie-policy',  title: 'Politica de cookie-uri',       type: 'basic', link: '/documente/politica-de-cookie-uri' },
                ],
            },
            { id: 'settings',        title: 'Setări',            type: 'basic', icon: 'heroicons_outline:cog-6-tooth',             link: '/setari' },
        ]
    },
];

export const adminOrderOperatorNavigation: FuseNavigationItem[] = [
    {
        id   : 'statistics',
        title: 'Statistici',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/statistici'
    },
    {
        id   : 'orders',
        title: 'Comenzi',
        type : 'basic',
        icon : 'heroicons_outline:credit-card',
        link : '/comenzi'
    },
    // Stands in for 'Produse digitale' — the only digital product this role reaches.
    {
        id   : 'simulations',
        title: 'Simulări',
        type : 'basic',
        icon : 'heroicons_outline:calculator',
        link : '/simulari'
    },
    {
        id   : 'simulation-lookup',
        title: 'Caută copil (simulări)',
        type : 'basic',
        icon : 'heroicons_outline:magnifying-glass',
        link : '/cauta-copil'
    }
];

// The simulation-day team: shared accounts that only find a child's room (name + room,
// nothing about the parent) — see AdminSimulationLookupController.
export const adminSimulationStaffNavigation: FuseNavigationItem[] = [
    {
        id   : 'simulation-lookup',
        title: 'Caută copil (simulări)',
        type : 'basic',
        icon : 'heroicons_outline:magnifying-glass',
        link : '/cauta-copil'
    }
];

// Marketing was part of the order operator's menu until it got its own role.
export const adminMarketingOperatorNavigation: FuseNavigationItem[] = [
    {
        id   : 'statistics',
        title: 'Statistici',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/statistici'
    },
    // Read-only: the course list with its resource links to copy, nothing to edit.
    {
        id   : 'courses',
        title: 'Cursuri',
        type : 'basic',
        icon : 'heroicons_outline:book-open',
        link : '/cursuri'
    },
    {
        id   : 'marketing',
        title: 'Marketing',
        type : 'basic',
        icon : 'heroicons_outline:device-phone-mobile',
        link : '/marketing'
    }
];

export const adminTestModuleOperatorNavigation: FuseNavigationItem[] = [
    {
        id   : 'statistics',
        title: 'Statistici',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/statistici'
    },
    {
        id   : 'academania',
        title: 'Academania',
        type : 'collapsable',
        icon : 'heroicons_outline:academic-cap',
        children: [
            {
                id   : 'exercises-tags',
                title: 'Tag-uri',
                type : 'basic',
                icon : 'heroicons_outline:book-open',
                link : '/academania/tag-manager'
            },
            {
                id   : 'exercise-modules',
                title: 'Module exerciții',
                type : 'basic',
                icon : 'heroicons_outline:calculator',
                link : '/academania/module-exercitii'
            },
            {
                id   : 'exercises-resources',
                title: 'Resurse',
                type : 'basic',
                icon : 'heroicons_outline:photo',
                link : '/academania/resurse'
            }
        ]
    }
];

export const adminTeacherNavigation: FuseNavigationItem[] = [
    {
        id   : 'statistics',
        title: 'Statistici',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/statistici'
    },
    {
        id   : 'files',
        title: 'Fișiere',
        type : 'basic',
        icon : 'heroicons_outline:folder',
        link : '/fisiere'
    },
    // The four below stand in for 'Produse digitale' — teachers get the flat
    // entries instead of the collapsable group.
    {
        id   : 'courses',
        title: 'Cursuri',
        type : 'basic',
        icon : 'heroicons_outline:book-open',
        link : '/cursuri'
    },
    {
        id   : 'group-products',
        title: 'Grupe Plus',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/grupe-plus'
    },
    {
        id   : 'summer-workshops',
        title: 'Ateliere de vară',
        type : 'basic',
        icon : 'heroicons_outline:sparkles',
        link : '/ateliere-de-vara'
    },
    {
        id   : 'summer-courses',
        title: 'Cursuri de vară',
        type : 'basic',
        icon : 'heroicons_outline:sun',
        link : '/cursuri-de-vara'
    },
    // Stands in for 'Corecturi'. Hidden by NavigationService when the teacher
    // has no papers waiting.
    {
        id   : 'simulations-marking',
        title: 'Corectare lucrări',
        type : 'basic',
        icon : 'heroicons_outline:pencil-square',
        link : '/simulari/corectare'
    },
    // Grupe Plus feedback for the teacher's own grupe. Hidden by NavigationService
    // when the teacher has no feedback round.
    {
        id   : 'group-feedback',
        title: 'Feedback',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-left-right',
        link : '/feedback'
    },
    {
        id   : 'playground',
        title: 'Jocuri',
        type : 'basic',
        icon : 'heroicons_outline:puzzle-piece',
        link : '/playground'
    }
];
